import { useEffect, useState } from "react"

/**
 * A version of useLocalStorage that works with SSR by initializing state in useEffect.
 * This prevents hydration mismatches.
 *
 * @param key
 * @param initialValue
 */
export function useLocalStorageSSR<T>(key: string, initialValue: T) {
  const [storedValue, setStoredValue] = useState<T>(initialValue)

  useEffect(() => {
    try {
      const item = localStorage.getItem(key)
      if (item !== null) setStoredValue(JSON.parse(item))
    } catch (err) {
      console.error(err)
    }
  }, [key, initialValue])

  const setValue = (value: T | ((storedValue: T) => T)) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value
      setStoredValue(valueToStore)
      localStorage.setItem(key, JSON.stringify(valueToStore))
    } catch (err) {
      console.log(err)
    }
  }

  return [storedValue, setValue] as const
}
